import { Component, OnInit, OnDestroy } from '@angular/core';
import { CartCreateDto, ProductOption } from '../../../../dto';
import { Utils } from '../../../../common';
import { CartService, ProductService, GaService } from '../../../../services';
import { BaseComponent } from '../../../../core';
import { PRODUCT_SHIPPING_TYPE } from '../../../../shared';
import * as CartStore from '../../../../store/cart';
@Component({
  selector: 'app-select-bulk-product',
  templateUrl: './select-bulk-product.component.html',
  styleUrls: ['./select-bulk-product.component.scss'],
})
export class SelectBulkProductComponent extends BaseComponent implements OnInit, OnDestroy {
  selectedProducts;
  sendSelectedProducts;
  isShowAddToCartModal: boolean;
  totalLength;

  constructor(private cartService: CartService, public productService: ProductService, private gaService: GaService) {
    super();
  }
  ngOnInit() {
    this.productService.openOptionSubject$.subscribe(() => {
      this.selectedProducts = this.productService.selectProducts;
      this.totalLength = this.selectedProducts.length + this.productService.cartsProductLength;
      if (this.totalLength > this.productService.maxProduct) {
        console.log(this.selectedProducts);
        this.selectedProducts = this.selectedProducts.map((selectedProduct, index) => {
          if (index + this.productService.cartsProductLength < this.productService.maxProduct) {
            return selectedProduct;
          } else {
            return {
              ...selectedProduct,
              addBulkChecked: false,
            };
          }
        });
      }
      this.sendSelectedProducts = this.selectedProducts;
      this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
      this.isShowAddToCartModal = true;
    });
  }

  checkUquickStockMoq(productOption: ProductOption) {
    if (!productOption.isFixedMoq && productOption.rocketStock) {
      if (productOption.rocketStock < 5) {
        productOption.minMoq = 1;
        productOption.inboxQuantity = 1;
      } else {
        if (productOption.minMoq === 1) {
          productOption.minMoq = 1;
          productOption.inboxQuantity = 1;
        } else {
          productOption.minMoq = 5;
          productOption.inboxQuantity = 5;
        }
      }
    }
    return productOption;
  }

  addToSelect(product) {
    let _selectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);

    if (!product.addBulkChecked) {
      if (this.productService.cartsProductLength + _selectedProducts.length >= this.productService.maxProduct) {
        const dialog = this._openDialog({
          message: `Cannot hold any more. Maximum of ${this.productService.maxProduct} can be held.`,
          close: () => {
            dialog.close();
          },
        });
        return;
      }
    }

    product.addBulkChecked = !product.addBulkChecked;
    this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
  }

  addBulkProducts() {
    if (this.sendSelectedProducts.length > 0) {
      let ret: any = [];
      this.selectedProducts = this.selectedProducts.filter((selectedProduct) => {
        if (selectedProduct.addBulkChecked) {
          ret.push(
            new CartCreateDto({
              mapperSaleProductId: Utils.toNumber(selectedProduct.id),
              quantity: Utils.toNumber(this.checkUquickStockMoq(selectedProduct.productOption).minMoq),
              shippingType:
                Utils.toNumber(selectedProduct.productOption.minMoq) > selectedProduct.productOption.rocketStock
                  ? PRODUCT_SHIPPING_TYPE.GENERAL
                  : Utils.toNumber(selectedProduct.productOption.minMoq) <= selectedProduct.productOption.rocketStock
                  ? PRODUCT_SHIPPING_TYPE.ROCKET
                  : Utils.toNumber(selectedProduct.productOption.minMoq) <= selectedProduct.productOption.stock
                  ? PRODUCT_SHIPPING_TYPE.STOCK
                  : PRODUCT_SHIPPING_TYPE.GENERAL,
              isForce: true,
            })
          );
          return false;
        } else {
          return selectedProduct;
        }
      });
      this.productService.selectProducts = this.selectedProducts;
      this.productService.emitResetProduct(this.selectedProducts);
      console.log(this.selectedProducts);
      // window.alert(`${ret.length}건 카트에 담기 아직 API 개발전`);

      this.cartService.addToCarts(ret).subscribe(
        (carts) => {
          const dialog = this._openDialog({
            message: this.i18n.t('CART.ADDED_MIN'),
            close: () => {
              dialog.close();
            },
          });
          this.store.dispatch(new CartStore.SetCart(carts));
          this.gaService.MOJI_AddToCart([carts]);
        },
        (error) => {
          // this.store.dispatch(new IndicatorStore.HideIndicator('addToCart'));
          this.errors = error;
          const errorDialog = this._openDialog({
            message: this.errors.message,
            close: () => {
              errorDialog.close();
            },
          });
        }
      );
      this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
      if (this.selectedProducts.length === 0) this.reset();
    }
  }

  reset() {
    this.isShowAddToCartModal = false;
    this.productService.selectProducts = [];
    this.productService.emitResetProduct();
  }

  onCloseAddToCartModal() {
    this.isShowAddToCartModal = false;
  }
}
